import React from 'react';
import { Validator } from 'utils/validator';
import { PInputText } from 'components/prime/PInputText/PInputText';
import { useLoginPageBLoC } from 'modules/PublicModule/pages/LoginPage/LoginPage.bloc';
import { FormField } from 'components/FormField/FormField';

export const LoginFormEmailField: React.FC = () => {
  const { form, setShowError } = useLoginPageBLoC();
  return (
    <FormField
      form={form}
      controller={{
        name: 'email',
        rules: {
          required: 'Please enter an email',
          maxLength: 255,
          pattern: {
            value: Validator.emailRegex,
            message: 'Please enter a valid email address',
          },
        },
      }}
      label="Email"
    >
      {({ field, fieldState }) => (
        <PInputText
          {...field}
          type="text"
          onBlur={() => {
            field.onChange(field.value.trim());
            field.onBlur();
          }}
          onChange={(e) => {
            setShowError(false);
            field.onChange(e);
          }}
          invalid={fieldState.invalid}
          data-testid="input-login-email"
        />
      )}
    </FormField>
  );
};
